module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vbl-dropdown"
  }, [_c('div', {
    on: {
      "click": function($event) {
        _vm.show = !_vm.show
      }
    }
  }, [_vm._t("default")], 2), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "dropdown-content"
  }, [_vm._t("content")], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2feb856e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblDropdown/src/vblDropdown.vue
// module id = 253
// module chunks = 0